var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00114 1.33325C6.25224 1.33325 4.83447 2.75102 4.83447 4.49992C4.83447 6.24882 6.25224 7.66659 8.00114 7.66659C9.75004 7.66659 11.1678 6.24882 11.1678 4.49992C11.1678 2.75102 9.75004 1.33325 8.00114 1.33325ZM5.83447 4.49992C5.83447 3.3033 6.80452 2.33325 8.00114 2.33325C9.19776 2.33325 10.1678 3.3033 10.1678 4.49992C10.1678 5.69654 9.19776 6.66659 8.00114 6.66659C6.80452 6.66659 5.83447 5.69654 5.83447 4.49992Z",
    fill: "#45AE51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00114 8.66659C6.64158 8.66659 5.38615 8.98042 4.45324 9.51351C3.53447 10.0385 2.83447 10.84 2.83447 11.8333C2.83447 12.8265 3.53447 13.628 4.45324 14.153C5.38615 14.6861 6.64158 14.9999 8.00114 14.9999C9.3607 14.9999 10.6161 14.6861 11.549 14.153C12.4678 13.628 13.1678 12.8265 13.1678 11.8333C13.1678 10.84 12.4678 10.0385 11.549 9.51351C10.6161 8.98042 9.3607 8.66659 8.00114 8.66659ZM3.83447 11.8333C3.83447 11.3537 4.17914 10.8219 4.94938 10.3818C5.70547 9.94971 6.78337 9.66659 8.00114 9.66659C9.21891 9.66659 10.2968 9.94971 11.0529 10.3818C11.8231 10.8219 12.1678 11.3537 12.1678 11.8333C12.1678 12.3128 11.8231 12.8446 11.0529 13.2847C10.2968 13.7168 9.21891 13.9999 8.00114 13.9999C6.78337 13.9999 5.70547 13.7168 4.94938 13.2847C4.17914 12.8446 3.83447 12.3128 3.83447 11.8333Z",
    fill: "#45AE51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRounded);
export default __webpack_public_path__ + "static/media/User Rounded.4bcca1f63832b9d7a6e4faebf4b36e7d.svg";
export { ForwardRef as ReactComponent };